import css from "./style.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth";
const HeaderLayout = () => {
  const navigate = useNavigate();
  const { isAdmin, logout } = useAuth();
  const handleLogout = () => {
    navigate("/");
    logout();
  };

  return (
    <header className={css["root"]}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 24 24"
      >
        <g
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          color="currentColor"
        >
          <path d="M11 11L6 6M5 7.5L7.5 5l-3-1.5l-1 1zm14.975 1.475a3.5 3.5 0 0 0 .79-3.74l-1.422 1.422h-2v-2l1.422-1.422a3.5 3.5 0 0 0-4.529 4.53l-6.47 6.471a3.5 3.5 0 0 0-4.53 4.529l1.421-1.422h2v2l-1.422 1.422a3.5 3.5 0 0 0 4.53-4.528l6.472-6.472a3.5 3.5 0 0 0 3.738-.79" />
          <path d="m11.797 14.5l5.604 5.604a1.35 1.35 0 0 0 1.911 0l.792-.792a1.35 1.35 0 0 0 0-1.911L14.5 11.797" />
        </g>
      </svg>
      {isAdmin ? (
        <button onClick={handleLogout} className={css.btn}>
          <b>Выйти</b>
        </button>
      ) : (
        <NavLink to="login" className={css["btn"]}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 21v-2h7V5h-7V3h7q.825 0 1.413.588T21 5v14q0 .825-.587 1.413T19 21zm-2-4l-1.375-1.45l2.55-2.55H3v-2h8.175l-2.55-2.55L10 7l5 5z"
            />
          </svg>
          Войти как администратор
        </NavLink>
      )}
    </header>
  );
};

export default HeaderLayout;
